import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Score from './Score';

export default
class LeaderboardScoreJudge extends Component {
    static propTypes = {
        scoreStyle: PropTypes.object.isRequired,
        colors: PropTypes.object.isRequired,
        judges: PropTypes.array.isRequired,
        roundConfig: PropTypes.object.isRequired,
        groupKey: PropTypes.number.isRequired
    }

    render() {
        const {
            scoreStyle,
            athlete,
            // colors,
            judges,
            roundConfig: {
                mostJudgesCount
            },
            groupKey
        } = this.props;

        const judgesScores = [
            ...judges || []
        ]
        .splice(
            0, mostJudgesCount
        );

        if (!judgesScores.length) {
            return (
                <div className="score judges">
                    <Score style={scoreStyle} />
                </div>
            );
        }

        return (
            <div className="score judges">
                <div>
                    {judgesScores
                    .map(({
                        judge,
                        drop,
                        rank
                    }, i) => {
                        const style = {};

                        // const style = drop
                        //     ? colors.drop
                        //     : {};

                        return (
                            <div
                                key={`leaderboard_judge_score_${athlete.externalId}_${groupKey}_${i}`}
                                className="judge-scores"
                            >
                                <Score
                                    style={{
                                        ...style,
                                        ...scoreStyle
                                    }}
                                >
                                    {rank}
                                </Score>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/scored/scores/Judge.js